export const FIELD_VALUE_UPDATED = 'ui2-field-value-updated'